
import { Button, Table } from 'antd'
import React from 'react'
import { CustomCol, CustomRow } from '../../../components/Custom'
import DetailTitle from '../../../components/DetailTitle'
import { apiAccountingRecordBillConfirmExport, fetchAccountingRecordBillConfirmLog } from '../../../services/accountingRecord'
import { findDict, ToParamForObject, handleExportParams } from '../../../utils'
import { mapAccountingRecordDataRange } from "../../../axios/dictionaries";
/**
 * @Author: zhao - 🍉
 * @Date: 2021-12-20 17:27:00
 * @LastEditTime: 2021-12-21 17:31:40
 * @LastEditors: zhao - 🍉
 * @Description: 租金汇集明细确认书
 * @FilePath: /zhzj-admin/src/page/AccountingRecord/components/BillConfirmLogView.jsx
 */
class BillConfirmLogView extends React.Component{
    constructor() {
        super()
        this.state = {
            dbillConfirmLogDataata: {}
        }
    }
    componentDidMount() {
        this.postAccountingRecordBillConfirmLog()
    }

    postAccountingRecordBillConfirmLog() {
        const data = { accountingRecordLogId: this.props.accountingRecordLogId }
        fetchAccountingRecordBillConfirmLog(data).then(res => {
            this.setState({ billConfirmLogData: res })
        })
    }
    render(){
        const { labelWidth } = this.props
        const { billConfirmLogData = {} } = this.state
       
        const otherExpensesConfirmColumns = [
            // { title: '开户行', dataIndex: 'bankName' },
            // { title: '开户行行号', dataIndex: 'bankNo' },
            // { title: '收款单位', dataIndex: 'accountName' },
            // { title: '收款账号', dataIndex: 'accountNumber' },
            { title: '费用名称', dataIndex: 'costName' },
            { title: '费用（元）', dataIndex: 'splitAmount' },
        ]
        const rentConfirmColumns = [
            { title: '楼栋', dataIndex: 'buildingName' },
            { title: '租金', dataIndex: 'rent' },
        ]
        const parmas = ToParamForObject({ 
            accountingRecordLogId: this.props.accountingRecordLogId,
            ...handleExportParams()
        })
        
        const exportUrl = apiAccountingRecordBillConfirmExport + '?' + parmas
        return (
            <div>
                <Button  type="primary" icon="export" href={exportUrl} style={{position: 'absolute', right: 0, top: 50}}>
                    导出
                </Button>
                <DetailTitle title="基础信息" />
                <CustomRow>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }} label="商户名称">
                        {billConfirmLogData.merchantName}
                    </CustomCol>
                    {/*<CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }} label="数据范围">*/}
                    {/*    {findDict(mapAccountingRecordDataRange, billConfirmLogData.dataRange).title}*/}
                    {/*</CustomCol>*/}
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="所属月份">
                        {billConfirmLogData.month}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="汇集期数">
                        {billConfirmLogData.collectionPeriod}
                    </CustomCol>
                </CustomRow>
                <CustomRow divider>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }} label="开始日期">
                        {billConfirmLogData.startDate}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="结束日期">
                        {billConfirmLogData.endDate}
                    </CustomCol>
                    <CustomCol labelStyle={{ width: labelWidth }} colStyle={{ paddingLeft: 5 }}  label="应汇集资金">
                        {billConfirmLogData.deductFeesTotal}
                    </CustomCol>
                </CustomRow>
                <DetailTitle title="应汇集资金明细" />
                <Table 
                    columns={otherExpensesConfirmColumns}
                    dataSource={billConfirmLogData.otherExpensesConfirmList}
                    scroll={{x: 900}}
                />
                {/*<DetailTitle title="租金已汇集明细" />*/}
                {/*<Table */}
                {/*    columns={rentConfirmColumns}*/}
                {/*    dataSource={billConfirmLogData.rentConfirmList}*/}
                {/*    scroll={{x: 900}}*/}
                {/*/>*/}
                
            </div>
        )
    }
}

export default BillConfirmLogView


// WEBPACK FOOTER //
// ./src/page/AccountingRecord/components/BillConfirmLogView.jsx